export var APLUS_LOGKEY = "/cnux.1.0";
export var APLUS_HOST = "gm.mmstat.com";
export var APLUS_URL = "https://".concat(APLUS_HOST).concat(APLUS_LOGKEY);
export var COOKIE_UID_KEY = "arms_uid";
export var COOKIE_UID_MAXAGE = 180 * 24 * 3600;
export var PREF_APLUS_LOGKEY = "/cnux.1.0";
export var PREF_APLUS_URL = "".concat(APLUS_HOST).concat(PREF_APLUS_LOGKEY);
export var VALUE_LIMIT = 512;
export var US_TIMEZONES = [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Adak",
    "Pacific/Honolulu",
    "America/Phoenix",
    "America/Indiana/Indianapolis",
    "America/Detroit",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/North_Dakota/Beulah"
];

 //# sourceMappingURL=constant.js.map